<template>
  <step :context="context" image="/images/rocket.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Legal Approvals</template>
    <template #guideDescription>
      You are responsible for compliance with any applicable privacy or data protection laws.
      Further, please note below whether, irrespective of a legal requirement to do so,
      you want to require your current loyalty customers to "opt in" with respect to participation in Loyalty XT.
    </template>
    <template #formTitle>Legal Approvals</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- General -->
        <v-radio-group
            v-model="model.legal.optIn"
            row
            hide-details
            :rules="[rules.required]"
        >
          <v-radio value="optIn">
            <div slot="label">I do want my <b>existing</b> customers to “opt in” to join the new loyalty program (powered by Loyalty XT).</div>
          </v-radio>
          <v-radio label="I do not want my customers to be required to 'opt in' to participate in Loyalty XT." value="doNotOptIn">
            <div slot="label">I do not want my <strong>existing</strong> customers to to “opt in” to join the new loyalty program (powered by Loyalty XT).</div>
          </v-radio>
        </v-radio-group>
        <div class="header mt-10">Marketing Opt In/Out</div>
        <div class="inline">
          I acknowledge that Opt In/Out to marketing communication, of existing members in my Revel CRM, will be migrated to Loyalty XT with their Marketing Opt In/Out status from Revel.
        </div>
        <img width='480' height='180' src="/images/revel-marketing-opt-in-out.png" />
        <v-tooltip
            v-model="showTooltip"
            top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
            >
              <v-icon color="grey lighten-1">
                mdi-alert-circle
              </v-icon>
            </v-btn>
          </template>
          <span>
             if this setting is not enabled all members will be migrated as Opt Out.<br/>
             If you manage this status in a separate communication platform<br/>
            please make to provide the data via email support@revelsystems.com<br/>
          </span>
        </v-tooltip>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import displayMixin from "@/mixins/display";

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step
  },
  created() {
    this.withTaxId = this.$parent.$attrs.withTaxId;
  },
  data() {
    return {
      valid: false,
      showTooltip: false,
      rules: {
        required: v => !!v || "Field is required",
      },
      model: {
        legal: {
          optIn: null,
        },
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", {...this.$data.model});
    },
  }
};
</script>

<style lang="scss" scoped>
.form {
  .general {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;

    #app.mobile & {
      grid-template-columns: 1fr;
    }
  }

  #app.desktop & {
    ::v-deep .establishments {
      .v-input--radio-group__input > .v-label {
        margin-bottom: -4px !important;
      }

      .v-text-field {
        .v-input__slot {
          width: 200px;
        }
      }
    }
  }
}
</style>
